module.exports = __webpack_public_path__ + "img/600.ae4ceaa0.svg";